<template>
  <div class='EnbUser'>
    <div class="cont-btn">
      <add-icon
      text="Adicionar um usuário"
      :active="true"
      :optionsLabel="{ width: '100px', marginTop: '90px', marginRight: '50px' }"
      @click="$router.push('/painel/users/register')"
      />
      <button v-if="false" @click="$router.push('/painel/users/register')">Adicionar</button>
      <input-search
      placeholder="Nome do usuário"
      action="SearchUserPainel"
      />
    </div>
    <div class="cont" @scroll="run">
      <user-header/>
      <user-list
      v-for="(data, key) in Users"
      :key="key"
      :data="data"
      :chave="key"
      />
      <div class="bottom">
        <vue-spinner v-if="load" size="45"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserHeader from './header/UserHeader'
import UserList from './Itens/UserList'
import AddIcon from '../Icons/AddIcon'
import InputSearch from '../Search/InputSearch'
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'EnbUser',
  components: { UserHeader, UserList, AddIcon, InputSearch, VueSpinner },
  data () {
    return {
      scroll: {
        position: 0,
        height: 1
      },
     load: false
    }
  },
  computed: {
    ...mapGetters(['Users'])
  },
  methods: {
    ...mapActions(['GetUser', 'Loading']),
    run (e) {
      this.scroll = {
        position: (e.target.offsetHeight + e.target.scrollTop),
        height: e.target.scrollHeight
      }
      if((this.scroll.height - this.scroll.position) <= 1) {
        //busca
        this.load = true
        setTimeout(() => {
          this.GetUser({
            params: {
              last: this.Users[this.Users.length - 1].id,
              limit: 5
            },
            init: false }).then(() => {
              this.load = false
            })
        }, 2000)
      }
    }
  },
  created () {
    this.Loading(true)
    this.GetUser({ params: { last: 0, limit: 15 }, init: true })
      .then(() => {
        this.Loading(false)
      })
  }
}
</script>

<style scoped>
.EnbUser {
  width: 100%;
  height: 98%;
}

.cont {
  width: 98%;
  height: 86%;
  padding: 1%;
  padding-bottom: 0;
  padding-top: 0;
  overflow: auto;
}

.cont-btn {
  padding-bottom: 1%;
  display: flex;
  justify-content: start;
  padding-left: 1%;
}

button {
  border: 0;
  font-size: 18px;
  padding: 1%;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 2%
}

.bottom {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .EnbUser {
    height: 75%;
  }
}
</style>
